/**
 * Created by zhangrp on 2018/8/28.
 */
import api from './index'

let exports = {};

//商业联盟-列表
exports.getBizUnionList = function (data, callback) {
    api.post('/bizUnion/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 上下文获取商业联盟-信息
exports.getBizUnionByContext = function (params, callback) {
    api.get('/bizUnion/get/by/context')
    .params(params)
    .done(callback)
    .go();
};

// 上下文获取 商业联盟-列表
exports.getBizUnionListForUsable = function (data, callback) {
    api.post('/bizUnion/list/get/for/usable')
    .data(data)
    .done(callback)
    .go();
};

//商业联盟-根据id查询
exports.getBizUnionById = function (data, callback) {
    api.post('/bizUnion/get/by/id')
    .data(data)
    .done(callback)
    .go();
};
//商业联盟-保存
exports.saveBizUnion = function (data, callback) {
    api.post('/bizUnion/save/do')
    .data(data)
    .done(callback)
    .go();
};
//商业联盟-修改
exports.updateBizUnion = function (data, callback) {
    api.post('/bizUnion/update/do')
    .data(data)
    .done(callback)
    .go();
};
//商业联盟-申请
exports.applyBizUnion = function (data, callback) {
    api.post('/bizUnion/apply/do')
    .data(data)
    .done(callback)
    .go();
};

//商业联盟-解散
exports.dissolveBizUnion = function (data, callback) {
    api.post('/bizUnion/dissolve/do')
    .data(data)
    .done(callback)
    .go();
};

// ==================== 商业联盟成员 =======================

exports.getBizUnionMemberInfo = function (params, callback) {    // 获取成员列表
    api.get('/bizUnion/biz/union/member/info/get')
    .params(params)
    .done(callback)
    .go();
};

exports.getBizUnionMemberList = function (data, callback) {    // 获取成员列表
    api.post('/bizUnion/biz/union/member/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveBizUnionMember = function (data, callback) {    // 单个保存联盟成员
    api.post('/bizUnion/biz/union/member/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateBizUnionMember = function (data, callback) {    // 修改联盟成员
    api.post('/bizUnion/biz/union/member/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateBizUnionMemberForBlacked = function (data, callback) {    // 成员加黑-解除加黑 操作
    api.post('/bizUnion/biz/union/member/blacked/set')
    .data(data)
    .done(callback)
    .go();
};

exports.moveBizUnionMember = function (data, callback) {    // 上下排序 操作
    api.post('/bizUnion/biz/union/member/move/do')
    .data(data)
    .done(callback)
    .go();
};

// ======================== 联盟库存 ====================== /goods/stock/list/get

exports.getGoodsStockListForBizUnion = function (data, callback) {    // 商业联盟-库存
    api.post('/bizUnion/goods/stock/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveGoodsStockShareRel = function (data, callback) {    // 商业联盟-共享库存-保存(共享)
    api.post('/bizUnion/goods/stock/share/rel/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteGoodsStockShareRel = function (params, callback) {    // 商业联盟-共享库存-取消共享
    api.get('/bizUnion/goods/stock/share/rel/delete/do')
    .params(params)
    .done(callback)
    .go();
};

exports.getGoodsStockShareRelList = function (data, callback) {    // 联盟公共库存分页列表
    api.post('/bizUnion/goods/stock/share/rel/list/get')
    .data(data)
    .done(callback)
    .go();
};

export default exports;


//////////////////
// WEBPACK FOOTER
// ./src/api/bizUnion.js
// module id = 97
// module chunks = 1